export const blogConstants ={
    ALLBLOG_REQUEST:"GET_ALLBLOG_REQUEST",
    ALLBLOG_SUCCESS:"GET_ALLBLOG_SUCCESS",
    ALLBLOG_ERROR:"GET_ALLBLOG_ERROR",

    VIEW_REQUEST:"GET_VIEW_REQUEST",
    VIEW_SUCCESS:"GET_VIEW_SUCCESS",
    VIEW_ERROR:"GET_VIEW_ERROR"
}